import classNames from "classnames";
import { UseFormRegisterReturn } from "react-hook-form";
import styles from "./index.module.scss";

type PropsType = {
  value?: string;
  leftOption: {
    label: string;
    value: string;
    inputProps:
      | UseFormRegisterReturn
      | { onChange: (event: React.ChangeEvent<HTMLInputElement>) => void };
  };
  rightOption: {
    label: string;
    value: string;
    inputProps:
      | UseFormRegisterReturn
      | { onChange: (event: React.ChangeEvent<HTMLInputElement>) => void };
  };
  className?: string;
  readOnly?: boolean; // Only selected side has unique styling
  controlled?: boolean;
};
const ToggleButtonUI = ({
  value,
  leftOption,
  rightOption,
  className,
  readOnly,
  controlled = false, // React-hook uses uncontrolled fields
}: PropsType) => {
  // We need the width of the buttons to vary depending on the length of the text
  // but also be the same for both halves of the button, which may have different # of chars
  const width =
    Math.max(leftOption.label.length, rightOption.label.length) * 10 + 50;

  const leftOptionProps = controlled
    ? {
        ...leftOption.inputProps,
        checked: value === leftOption.value,
      }
    : leftOption.inputProps;
  const rightOptionProps = controlled
    ? {
        ...rightOption.inputProps,
        checked: value === rightOption.value,
      }
    : rightOption.inputProps;

  return (
    <fieldset className={classNames(className, styles.radioGroupFieldset)}>
      <>
        {/* LEFT HALF */}
        <label
          style={{ width: `${width}px` }}
          className={classNames(
            classNames,
            styles.radioInputLabel,
            styles.radioInputLabelLeft,
            {
              [styles.radioInputLabelSelected]: value === leftOption.value,
              [styles.radioInputLabelReadOnly]:
                value === leftOption.value && readOnly,
            }
          )}
          htmlFor={leftOption.value}
          key={leftOption.value}
        >
          <input
            type="radio"
            className={classNames(classNames, styles.radioInput)}
            id={leftOption.value}
            value={leftOption.value}
            disabled={readOnly}
            {...leftOptionProps}
          />
          <span className={styles.radioInputLabelText}>{leftOption.label}</span>
        </label>
        {/* RIGHT HALF */}
        <label
          style={{ width: `${width}px` }}
          className={classNames(
            classNames,
            styles.radioInputLabel,
            styles.radioInputLabelRight,
            {
              [styles.radioInputLabelSelected]: value === rightOption.value,
              [styles.radioInputLabelReadOnly]:
                value === rightOption.value && readOnly,
            }
          )}
          htmlFor={rightOption.value}
          key={rightOption.value}
        >
          <input
            type="radio"
            className={classNames(classNames, styles.radioInput)}
            id={rightOption.value}
            value={rightOption.value}
            disabled={readOnly}
            {...rightOptionProps}
          />
          <span className={styles.radioInputLabelText}>
            {rightOption.label}
          </span>
        </label>
      </>
    </fieldset>
  );
};

export default ToggleButtonUI;
